import { render, staticRenderFns } from "./PeopleListEmptyWidget.vue?vue&type=template&id=12abab57"
import script from "./PeopleListEmptyWidget.vue?vue&type=script&lang=js"
export * from "./PeopleListEmptyWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports